import React from "react";
import type {VoidFunctionComponent} from "react";
import {useSongsMobileFilterNavLogic} from "./SongsMobileFilterNav.logic";
import {FontIcon} from "../../../../components/common/FontIcon";
import { NavLink } from "react-router-dom";

export interface ISongsMobileFilterNavProps {
  useClassName?: string;
}

export const SongsMobileFilterNav: VoidFunctionComponent<ISongsMobileFilterNavProps> = ({useClassName}) => {
  const {isFilterActive, filterPageUrl} = useSongsMobileFilterNavLogic();
  return (
    <NavLink to={filterPageUrl}>
      <button className={useClassName} aria-label={"Filter"}>
        <FontIcon icon={isFilterActive ? "icon-filter-solid" : "icon-filter"}/>
      </button>
    </NavLink>
  );
}
